import React from "react";
import {Grid, Icon} from '@material-ui/core';
import classes from './MyRoles.module.css';
import myRolesData from '../../assets/static/myroles.json';

const MyRoles = () =>  {
	let roles = myRolesData.roles;
	return (
		<Grid container spacing={4} className={classes.MyRoles}>
			<Grid item xs={12}>
				<h2 className={classes.Header}>What <span className={classes.SubHeader}>I Do</span></h2>
			</Grid>
			{
				roles.map(role => (
					<Grid item xs={12} sm={6} key={role.id}>
						<div className={classes.Icon}>
							<Icon fontSize="large">{role.icon}</Icon>
						</div>
						<div className={classes.Title}>
							{role.title}
						</div>
						<p className={classes.Description}>
							{role.description}
						</p>
					</Grid>
				))
			}
		</Grid>
	)
}
export default MyRoles;